import { MatchExtended } from '../../shared/model/match';

export interface ControlMatch extends MatchExtended {
  priority: number;
  manualOrder?: number;
  categoryColor: string;
  progressPercent?: number;
  estimatedMinutesLeft?: number;
  playerAvailable: boolean;
  globalPosition?: number;
}

export interface PlayerMatchStats {
  playerId: string;
  playerName: string;
  matchesPlayed: number;
  matchesInProgress: number;
  lastMatchEndedAt?: number;
}

export interface CourtStatus {
  name: string;
  match: ControlMatch | null;
}

// Paleta vívida tipo neón — máxima saturación, distribuida por la rueda de
// color para separar al máximo las categorías. Todos los tonos brillan sobre
// fondo oscuro y mantienen suficiente luminosidad para texto negro encima.
export const CATEGORY_COLORS: Record<string, string> = {
  'juvenil':  '#00E5FF', // verde neón
  'damas':    '#FF1493', // rosa shocking
  'primera':  '#00B0FF', // azul eléctrico
  'segunda':  '#00E676', // cian neón
  'tercera':  '#FF8C00', // naranja vivo
  'cuarta':   '#B266FF', // violeta eléctrico
  'quinta':   '#FFD600', // amarillo dorado
  'sexta':    '#80DEEA', // celeste claro
  'novatos':  '#CFFF00', // verde lima
  'infantil': '#FF5252', // rojo coral
  'Damas A':  '#FF1FAE', // fucsia (1 Open Femenino Squash)
  'Damas B':  '#FF80D5', // fucsia claro (1 Open Femenino Squash)
};
